export class CountryStatesParams {
    public forLegacy: boolean;
    public addressType: Number;
    public countryId: Number;
}


// WEBPACK FOOTER //
// ./src/custom_modules/autocomplete/models/countryStatesParams.ts